import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import fondo from "./taxis.png";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  layout: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: `calc(100% - ${drawerWidth}px)`,
    minHeight: "100vh",
    marginLeft: drawerWidth,
    padding: theme.spacing(10, 4, 3),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0,
      padding: theme.spacing(10, 2, 2),
    },
    "@supports (min-height: 100dvh)": {
      minHeight: "100dvh",
    },
  },
  logo: {
    display: "block",
    width: "100%",
    maxWidth: 560,
    maxHeight: "calc(100vh - 112px)",
    height: "auto",
    objectFit: "contain",
    [theme.breakpoints.down("xs")]: {
      maxWidth: 440,
      maxHeight: "calc(100vh - 104px)",
    },
    "@supports (height: 100dvh)": {
      maxHeight: "calc(100dvh - 112px)",
    },
  },
}));

export default function Home() {
  const classes = useStyles();

  return (
    <main className={classes.layout}>
      <img
        src={fondo}
        alt="Logotipo de la Associació Provincial d'Auto Taxis de Lleida"
        className={classes.logo}
      />
    </main>
  );
}
